import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-teclado',
  templateUrl: './teclado.component.html',
  styleUrls: ['./teclado.component.scss']
})
export class TecladoComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  utils: any;
  codejs: string = `
/* Inicialización del componente teclado */
utils.initTeclado();
/* Retorna valor y borra los datos del campo */
//Es6
let getTecladoValue = () => {
	let password = utils.getValueTeclado();
}
//Es5
var getTecladoValue = function getTecladoValue() {
    var password = utils.getValueTeclado();
};`;

  codehtml: string = `<div class="container-keyboard-password">
  <label for="password-keyboard">Contraseña</label>
  <div class="input-group">
      <input id="password-keyboard" type="tel" class="input-govco form-control teclado-password" onfocus="utils.onInputPassword()"
          onKeyDown="return false" pattern="[0-9]*" inputmode="numeric"/>
      <div class="input-group-append svg-block send-button-password" onclick="getTecladoValue()">
          <span class="govco-icon govco-icon-padlock-n"></span>
      </div>
  </div>
  <div class="input-group form-inline">
      <table class="tb-teclado-item" id="keyboard">
          <tr>
              <td colspan="3"></td>
          </tr>
          <div class="div-numbers">
              <tr>
                  <td class="td-number">
                      <button class="td-number-item" value="1">1</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="2">2</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="3">3</button>
                  </td>
              </tr>
              <tr>
                  <td class="td-number">
                      <button class="td-number-item" value="4">4</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="5">5</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="6">6</button>
                  </td>
              </tr>
              <tr>
                  <td class="td-number">
                      <button class="td-number-item" value="7">7</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="8">8</button>
                  </td>
                  <td class="td-number">
                      <button class="td-number-item" value="9">9</button>
                  </td>
              </tr>
              <tr>
                  <td></td>
                  <td class="td-number">
                      <button class="td-number-item" value="0">0</button>
                  </td>
                  <td class="td-number-disable">
                      <button class="btn-disable">
                          <div class="btn-delete btn-delete-teclado">
                              <span class="govco-icon govco-icon-tag-n"></span>
                          </div>
                      </button>
                  </td>
              </tr>
          </div>
      </table>
  </div>
</div>`; 
    highlighted: boolean = false;


  constructor(private highlightService: HighlightService) {
    this.utils = window.utils;
      this.infoComponent = {
        titulo: "Teclado",
        subtitulo: "Permite el ingreso de datos numéricos para interacciones de escritorio, para interacciones móviles cada sistema operativo desplegará su propio teclado.",
      }

  }
  getTecladoValue() {
    let password = this.utils.getValueTeclado();
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.initTeclado();
  }

}
